import transformDynamicTrack from './transformDynamicTrack'
import {reduce, get} from 'lodash'
export default function mergeDynamicDataToDoc(doc) {

  const dynamicAttributes = get(doc, 'content.metadata.dynamicItems')
  const {powtoon, powtoon: {slides}} = doc.content
  const {dynamic_data: dynamicData} = doc
  if (!dynamicAttributes || !Array.isArray(Object.keys(dynamicAttributes)) || !dynamicData) {
    return doc
  }

  const newSlides = reduce(slides, (newSlides, slide) => {
    const newTracks = reduce(slide.tracks, (newTracks, track) => {
      let newTrack = AddToItemTransformers(track, dynamicData, dynamicAttributes, track.id) // for text
      newTrack = AddToItemTransformers(newTrack, dynamicData, dynamicAttributes, track.sprites['0'].id) //for rest od dynamic fields
      newTracks.push(newTrack)
      return newTracks
    }, [])
    newSlides.push({
      ...slide,
      tracks: newTracks
    })
    return newSlides
  }, [])

  const newDoc = {
    ...doc,
    content: {
      ...doc.content,
      powtoon: {
        ...powtoon,
        slides: newSlides
      }
    }
  
  }
  return newDoc
}

function AddToItemTransformers (track, dynamicData, dynamicAttributes, id){
  if (!dynamicAttributes[id] ) {
    return track
  }
  return transformDynamicTrack(track, {dynamicData, dynamicAttributesForTrack: dynamicAttributes[id]})
}
